export default __webpack_public_path__ + "static/MediaMainBanner-a14a1de2b31174daffd9562c4e7b8ab7.webp";